import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class AsnOrders_ds_orders_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: {  }): 
  Promise<{ result: { Id?: number, AccountId?: number, BillingAddresId?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, OwnerReference?: string, ProjectId?: number, VendorReference?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_orders_grid/get`;
    
    const options = {
    }
    
    const body = null;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AccountId?: number, BillingAddresId?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, OwnerReference?: string, ProjectId?: number, VendorReference?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_orders_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, AccountId?: number, BillingAddresId?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, OwnerReference?: string, ProjectId?: number, VendorReference?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_orders_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
